/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LearningRecordInterface, RegistrationInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class RegistrationApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Registrations');
  }

  createLearningRecord(
    registrationId: number,
    learningRecord: LearningRecordInterface
  ): Observable<LearningRecordInterface> {
    const path = `${registrationId}/createLearningRecord`;
    return this.post<LearningRecordInterface>(path, undefined, learningRecord);
  }

  createRegistration(registration: Partial<RegistrationInterface>): Observable<RegistrationInterface> {
    const path = 'createRegistration';
    return this.post<RegistrationInterface>(path, undefined, registration);
  }
}
